module.exports = __webpack_public_path__ + "img/banner-services-mobile-min.4c612dc0.jpg";